// removed by extract-text-webpack-plugin
module.exports = {"pagination-container":"pagination-container___3VWUM","paginator":"paginator___3Z9Gr","break":"break___3EiEL","disabled":"disabled___1ckQv","grayed":"grayed___2b6y5","pagination-view-count":"pagination-view-count___2eR0Y","page-size":"page-size___8XSeH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/PaginationWrapper.scss
// module id = BXmT
// module chunks = 46